/**

 * Languages: English (default) + Danish, Swedish, Norwegian.

 */



export const SUPPORTED_LOCALES = [

  { id: 'en', label: 'English' },

  { id: 'da', label: 'Dansk' },

  { id: 'sv', label: 'Svenska' },

  { id: 'no', label: 'Norsk' },

];



export const BUILDER_UI_LOCALES = SUPPORTED_LOCALES;



export const DEFAULT_LOCALE = 'en';

